import { Component, Input } from '@angular/core';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { ApiService } from '../../../../services/api';
import { Organization } from '../../../../model/organization';

@Component({
    selector: 'staff-org-reports',
    templateUrl: 'reports.html'
})
export class OrganizationReportsSection {
    _organization: Organization;
    _viewMode: string = 'nominatedOffspring';

    selectedRodeoEvent: RodeoEvent;

    popoverActive: boolean;
    loadingData: boolean;

    hasExhibitions: boolean;
    hasSidepots: boolean;

    @Input()
    set organization(organization: Organization) {
        if (organization != null) {
            this._organization = organization;
        }
    }
    get organization(): Organization {
        return this._organization;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    constructor(public api: ApiService) { 
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/reports/reports.ts